( function( $ ) {
	function swiperTestimonialsCustomChange( swiper ) {
		let $prev = $( swiper.el ).find( '.swiper-slide-prev' );
		let prevAuthor = $prev.find( '.testimonials-card__author' ).text();
		let prevImgSrc;

		if ( $prev.find( 'img' ).length ) {
			prevImgSrc = $prev.find( 'img' ).attr( 'src' );
		} else if ( $prev.find( 'video' ).length ) {
			prevImgSrc = $prev.find( 'video' ).attr( 'poster' );
		} else {
			prevImgSrc = '';
		}

		let $next = $( swiper.el ).find( '.swiper-slide-next' );
		let nextAuthor = $next.find( '.testimonials-card__author' ).text();
		let nextImgSrc;

		if ( $next.find( 'img' ).length ) {
			nextImgSrc = $next.find( 'img' ).attr( 'src' );
		} else if ( $next.find( 'video' ).length ) {
			nextImgSrc = $next.find( 'video' ).attr( 'poster' );
		} else {
			nextImgSrc = '';
		}

		let $btnPrev = $( swiper.el ).parents( '.section-testimonials__main' ).find( '.js-swiper-testimonials-custom-prev' );
		let $btnNext = $( swiper.el ).parents( '.section-testimonials__main' ).find( '.js-swiper-testimonials-custom-next' );

		$btnPrev.addClass( 'is-animating' );
		$btnNext.addClass( 'is-animating' );


		setTimeout( function() {
			$btnPrev.find( 'img' ).attr( 'src', prevImgSrc );
			$btnPrev.find( '.swiper-button-image__author' ).html( prevAuthor );

			$btnNext.find( 'img' ).attr( 'src', nextImgSrc );
			$btnNext.find( '.swiper-button-image__author' ).html( nextAuthor );

			$btnPrev.removeClass( 'is-animating' );
			$btnNext.removeClass( 'is-animating' );
		}, 500 );
	}

	function setPaddingMarginToCards() {
		let $cards = $( '.js-swiper-reviews-v4 .testimonials-card' );

		if ( !$cards.length ) {
			return;
		}

		let $container = $( '.container' ).first();

		let containerPadding = $container.innerWidth() - $container.width();
		let containerMargin = $container.outerWidth( true ) - $container.outerWidth();

		$( '.js-swiper-reviews-v4 .testimonials-card' ).css( 'padding-left', containerPadding / 2 ).css( 'margin-left', containerMargin / 2 );
	}

	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-testimonials' );

		$( '.testimonials-card__video' ).on( 'click', ( e ) => {
			e.preventDefault();
		} );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			const $sectionInstance = $( this );

			const loadSliders = () => {
				$sectionInstance.find( '.js-swiper-testimonials-gallery' ).each( function() {
					const $slider = $( this );

					if ( this.swiper ) {
						this.swiper.destroy( true, true );

						$slider
							.parents( '.gallery-wrapper' )
							.find( '.swiper-button-next' )
							.removeClass( 'swiper-button-lock' )
							.removeAttr( 'disabled' );

						$slider
							.parents( '.gallery-wrapper' )
							.find( '.swiper-button-prev' )
							.removeClass( 'swiper-button-lock' )
							.removeAttr( 'disabled' );
					}

					$slider.removeClass( 'swiper-has-padding' );

					const swiperSlideLength = $slider.find( '.swiper-slide' ).length;
					let slidesCount = 5;
					let loop = false;

					if (
						swiperSlideLength > 5 && window.matchMedia( 'screen and (min-width: 768px)' ).matches ||
						swiperSlideLength > 4 && window.matchMedia( 'screen and (max-width: 767.5px)' ).matches
					) {
						$slider.addClass( 'swiper-has-padding' );

						slidesCount = 4;

						loop = true;
					}

					new Swiper( $slider[0], {
						slidesPerView: slidesCount - 1,
						slidesPerGroup: 1,
						spaceBetween: 3,
						loop,
						loopedSlides: 6,
						loopAdditionalSlides: 6,
						a11y: {
							enabled: false
						},
						speed: 1000,
						slideToClickedSlide: true,
						watchOverflow: true,
						breakpoints: {
							768: {
								slidesPerView: slidesCount,
								slidesPerGroup: 2,
								spaceBetween: 4,
							},
							1280: {
								slidesPerView: slidesCount,
								slidesPerGroup: 2,
								spaceBetween: 10,
							},
						},
						navigation: {
							nextEl: $slider.parents( '.gallery-wrapper' ).find( '.swiper-button-next' )[0],
							prevEl: $slider.parents( '.gallery-wrapper' ).find( '.swiper-button-prev' )[0],
						},
					} );
				} );

				$sectionInstance.find( '.js-swiper-testimonials-default' ).each( function() {
					const $slider = $( this );

					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}

					let loop = false;

					if ( $slider.find( '.swiper-slide' ).length > 1 ) {
						loop = true;
					}

					new Swiper( $slider[0], {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 0,
						loop,
						loopedSlides: 10,
						loopAdditionalSlides: 10,
						speed: 1000,
						effect: 'fade',
						simulateTouch: false,
						fadeEffect: {
							crossFade: true,
						},
						navigation: {
							nextEl: $slider.parents( '.section-testimonials__default-testimonials' ).find( '.swiper-button-next' )[0],
							prevEl: $slider.parents( '.section-testimonials__default-testimonials' ).find( '.swiper-button-prev' )[0],
						},
						pagination: {
							el: $slider.parents( '.section-testimonials__default-testimonials' ).find( '.swiper-pagination' )[0],
							type: 'fraction',
						}
					} );
				} );

				$sectionInstance.find( '.js-swiper-testimonials-custom' ).each( function() {
					const $slider = $( this );
					let initialLoading = true;

					if ( $slider[0].swiper ) {
						$slider[0].swiper.destroy( true, true );
						initialLoading = false;
					}

					const slidesCount = $slider.find( '.swiper-slide' ).length;

					new Swiper( $slider[0], {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 0,
						loop: true,
						loopedSlides: 10,
						loopAdditionalSlides: 10,
						a11y: {
							enabled: false
						},
						speed: 1000,
						effect: 'fade',
						centeredSlides: true,
						observer: true,
						observeParents: true,
						normalizeSlideIndex: true,
						simulateTouch: false,
						fadeEffect: {
							crossFade: true,
						},
						navigation: {
							nextEl: $slider.parents( '.section-testimonials__main' ).find( '.swiper-button-next' )[0],
							prevEl: $slider.parents( '.section-testimonials__main' ).find( '.swiper-button-prev' )[0],
						},
						pagination: {
							el: $slider.parents( '.section-testimonials__main' ).find( '.swiper-pagination' )[0],
							type: 'fraction',
						},
						on: {
							init: function() {
								const swiper = this;

								if ( !initialLoading ) {
									swiperTestimonialsCustomChange( swiper );
								}

								const $btnPrev = $( this.el ).parents( '.section-testimonials__main' ).find( '.js-swiper-testimonials-custom-prev' );
								const $btnNext = $( this.el ).parents( '.section-testimonials__main' ).find( '.js-swiper-testimonials-custom-next' );

								if ( slidesCount > 1 ) {
									$btnPrev.on( 'click', function() {
										swiper.slidePrev( 1000 );
									} );

									$btnNext.on( 'click', function() {
										swiper.slideNext( 1000 );
									} );
								}
							},
							slideChangeTransitionStart: function() {
								if ( !initialLoading ) {
									swiperTestimonialsCustomChange( this );
								}
							},
							afterInit: function() {
								initialLoading = false;
							}
						}
					} );

					const $sliderParent = $slider.parents( '.section-testimonials__main' );
					const $swiperButtonPrev = $sliderParent.find( '.swiper-button-prev' );
					const $swiperButtonNext = $sliderParent.find( '.swiper-button-next' );
					const $swiperButtonImage = $sliderParent.find( '.swiper-button-image' );

					if ( slidesCount <= 1 ) {
						$swiperButtonNext.addClass( 'swiper-button-lock' );
						$swiperButtonPrev.addClass( 'swiper-button-lock' );
						$swiperButtonImage.addClass( 'disabled' );
					} else {
						$swiperButtonNext.removeClass( 'swiper-button-lock' );
						$swiperButtonPrev.removeClass( 'swiper-button-lock' );
						$swiperButtonImage.removeClass( 'disabled' );
					}
				} );

				$sectionInstance.find( '.js-swiper-reviews' ).each( function() {
					const $slider = $( this );

					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}

					const slideCount = $slider.children( '.swiper-wrapper' ).children( '.swiper-slide' ).length;
					let loop = false;
					let rewind = true;

					const handleSliderSettings = () => {
						if (
							slideCount > 3 && window.matchMedia( 'screen and (min-width: 1025px)' ).matches ||
							slideCount > 4 && window.matchMedia( 'screen and (min-width: 2000px)' ).matches ||
							slideCount > 2 && window.matchMedia( 'screen and (max-width: 1024.5px)' ).matches
						) {
							loop = true;
							rewind = false;
						}
					};

					const loadSlider = () => {
						handleSliderSettings();
						new Swiper( $slider[0], {
							slidesPerView: 'auto',
							slidesPerGroup: 1,
							speed: 1000,
							spaceBetween: 8,
							slideToClickedSlide: true,
							rewind,
							loop,
							loopedSlides: 10,
							simulateTouch: false,
							a11y: {
								enabled: false
							},
							navigation: {
								nextEl: $slider.find( '.swiper-button-next' )[0],
								prevEl: $slider.find( '.swiper-button-prev' )[0],
							},
							breakpoints: {
								768: {
									spaceBetween: 12,
								},
								1280: {
									spaceBetween: 24,
								},
								1720: {
									spaceBetween: 30,
								}
							}
						} );

						if (
							$slider.find( '.swiper-button-prev' ).hasClass( 'swiper-button-lock' ) &&
							$slider.find( '.swiper-button-next' ).hasClass( 'swiper-button-lock' )
						) {
							$slider.find( '.swiper-controls' ).addClass( 'd-none' );
						} else {
							$slider.find( '.swiper-controls' ).removeClass( 'd-none' );
						}
					};

					loadSlider();
				} );

				$sectionInstance.find( '.js-swiper-reviews-gallery' ).each( function() {
					const $slider = $( this );

					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}

					new Swiper( $slider[0], {
						slidesPerView: 'auto',
						speed: 1000,
						spaceBetween: 4,
						slideToClickedSlide: true,
						centeredSlides: false,
						rewind: true,
						a11y: {
							enabled: false
						},
						mousewheel: {
							releaseOnEdges: true,
						},
					} );
				} );

				setPaddingMarginToCards();

				$sectionInstance.find( '.js-swiper-reviews-v4' ).each( function() {
					const $slider = $( this );

					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}

					new Swiper( $slider[0], {
						slidesPerView: 'auto',
						spaceBetween: -2,
						loop: true,
						navigation: {
							nextEl: $slider.parents( '.section-testimonials__main' ).find( '.swiper-button-next' )[0],
							prevEl: $slider.parents( '.section-testimonials__main' ).find( '.swiper-button-prev' )[0],
						},
						pagination: {
							el: $slider.parents( '.section-testimonials__main' ).find( '.swiper-pagination' )[0],
							type: 'fraction',
						},
						on: {
							afterInit: function() {
								setPaddingMarginToCards();
							}
						}
					} );
				} );
			};

			window.app.loadVendor( 'Swiper', loadSliders );
		} );
	};

	window.app.loadBlock( initBlock, 'section-testimonials', '.section-testimonials' );
} )( jQuery );
